module.exports = __webpack_public_path__ + "static/media/micDisabled_filled_light.2522f50a.svg";